// German (DE) translations for Find-2-Day
const de = {
  translation: {
    "partnersStep3": "Wenn ein von Ihnen vermitteltes Unternehmen zahlt — sein erstes Abonnement, eine Verlängerung oder einen Boost — erhalten Sie 50% dieser Zahlung (ohne MwSt.). Das erscheint automatisch in Ihrem Partner-Dashboard, bei jeder Zahlung.",
    "partnersLede": "Sind Sie Stadtbotschafter, Gemeinschaftsgruppe oder lokaler Vorreiter? Stellen Sie Find-2-Day Unternehmen in Ihrer Nähe vor: Sie erhalten 50% jeder Zahlung (ohne MwSt.), solange sie dabei bleiben — das erste Abonnement, jede Verlängerung und jeden Boost bzw. gesponserten Beitrag.",
    "partnersCommissionExplainer": "Sie erhalten 50% von allem, was ein von Ihnen vermitteltes Unternehmen zahlt: das erste Abonnement, jede monatliche oder jährliche Verlängerung und jeden Boost bzw. gesponserten Beitrag. Die Preise enthalten 21% MwSt.; Ihre Provision wird auf den Betrag ohne MwSt. berechnet.",
    "partnersRenewalHeading": "Abonnements & Verlängerungen",
    "partnersRenewalDesc": "50% der ersten Zahlung und jeder Verlängerung eines vermittelten Unternehmens, solange es abonniert bleibt.",
    "partnersPoint2": "Sobald es ein Abonnement, eine Verlängerung, einen Boost oder einen gesponserten Beitrag bezahlt, erhalten Sie 50% des gezahlten Betrags (ohne MwSt.).",
    "partnersPoint3": "Jedes Unternehmen, das Sie vermitteln, ist Ihnen dauerhaft zugeordnet. Solange es weiter zahlt, verdienen Sie weiter 50% — ein Leben lang.",
    "affEarnTitle": "Was Sie pro Tarif verdienen",
    "affEarnIntro": "Die Preise enthalten 21% MwSt. Ihre Provision von 50% wird auf den Betrag ohne MwSt. berechnet. Qualifizierte Abonnements zahlen Ihnen ein Leben lang — die erste Zahlung und jede Verlängerung.",
    "affEarnColPlan": "Tarif",
    "affEarnColPrice": "Preis (inkl. MwSt.)",
    "affEarnColCommission": "Ihre Provision (pro Zahlung)",
    "affEarnPerMonth": "/Monat",
    "affEarnPerYear": "/Jahr",
    "affEarnPlanBasic": "Basic",
    "affEarnPlanPlus": "Business Plus",
    "affEarnLifetimeNote": "Sie erhalten die obige Provision bei der ersten Zahlung und bei jeder Verlängerung, solange das Abonnement besteht.",
    "affEarnBoostNote": "Boosts & gesponserte Beiträge: Sie erhalten außerdem 50% jedes bezahlten Boosts oder gesponserten Beitrags, den ein vermitteltes Unternehmen kauft.",
    "verifyEmailWarn": "Bitte bestätigen Sie Ihre E-Mail, um Provisionsauszahlungen zu aktivieren.",
    "resendVerification": "E-Mail erneut senden",
    "sending": "Senden…",
    "verifyResent": "Bestätigungs-E-Mail gesendet — prüfen Sie Ihr Postfach.",
    "payoutHoldWarn": "Ihre Bankdaten wurden kürzlich geändert, daher sind Auszahlungen aus Sicherheitsgründen kurz pausiert.",
    "clawbackWarn": "Ein offener Betrag von {{amt}} € aus einer Rückerstattung/Rückbuchung wird von künftigen Provisionen abgezogen.",
    "downloadEarnings": "Verdienstübersicht (CSV)",
    "downloadPayouts": "Auszahlungsübersicht (CSV)",
    "partnersPoint1": "Unternehmen können Find-2-Day mit einem dauerhaft KOSTENLOSEN Basis-Verzeichniseintrag beitreten. Optionale kostenpflichtige Abos und Werbedienste sind verfügbar. Bestehende Gründungsunternehmen behalten ihre ursprünglich zugesagten 12 Gratismonate.",
    "partnersPoint4": "Provisionen werden 30 Tage einbehalten. Wird eine Zahlung erstattet oder eine Rückbuchung erfolgreich, kann ihre Provision rückgängig gemacht werden. Bereits ausgezahlte Provisionen können mit künftigen Einnahmen verrechnet werden.",
    "howPayoutsRule6": "Wird eine Zahlung erstattet oder eine Rückbuchung erfolgreich, kann ihre Provision rückgängig gemacht werden — auch bereits ausgezahlte Provisionen, die mit künftigen Einnahmen verrechnet werden können.",
    "lifetimeRenewalEarningsHint": "Sie verdienen dies, sobald Ihre vermittelten Unternehmen verlängern. Sie müssen nichts weiter tun — wir erfassen es für Sie.",
    "renewalCommissionTooltip": "Provision verdient, weil dieses Unternehmen sein Abo verlängert hat",
    "communityPartner": {
      "title": "Community-Partner werden",
      "label": "Community-Partner werden",
      "tagline": "Verdienen Sie ",
      "taglineRest": " lebenslange Provision auf alles, was Ihre vermittelten Unternehmen zahlen (ohne MwSt.).",
      "cta": "Mehr erfahren"
    },
    "membership": {
      "chooseTitle": "Wählen Sie Ihre Mitgliedschaft",
      "chooseSubtitle": "Kostenlos starten oder Ihr vollständiges Profil freischalten. Preise inkl. MwSt.",
      "freeForever": "Für immer kostenlos · keine Karte nötig",
      "chooseFree": "Kostenloses Verzeichnis wählen",
      "month": "Monat",
      "year": "Jahr",
      "trial60": "Erste 60 Tage gratis",
      "ivaIncluded": "inkl. MwSt.",
      "chooseBasic": "Basic wählen",
      "plusName": "Business Plus",
      "orAnnual": "oder",
      "choosePlusMonthly": "Monatlich",
      "choosePlusAnnual": "Jährlich",
      "consentNote": "Bezahlte Tarife beginnen mit einer kostenlosen 60-tägigen Testphase. Es wird erst nach Ablauf der Testphase abgebucht und nur, wenn Sie zugestimmt haben. Jederzeit kündbar.",
      "freeBadge": "Kostenloses Verzeichnis",
      "freeTitle": "Kostenloser Eintrag — €0 für immer",
      "freeBody": "Ihr Basis-Eintrag (Firmenname, Kategorie und Ort) wird nach der Freigabe veröffentlicht. Keine Karte nötig. Sie können jederzeit auf Basic oder Business Plus upgraden, um alle Ihre Daten anzuzeigen.",
      "paidBody": "Ihr Eintrag wird nach der Freigabe veröffentlicht. In den ersten 60 Tagen wird NICHTS abgebucht. Nach Ablauf der kostenlosen Testphase wird Ihre Karte automatisch belastet, nur wenn Sie zugestimmt haben – und Sie können vorher jederzeit kündigen.",
      "firstChargeOn": "Erste Abbuchung (falls Sie fortfahren):",
      "checkoutNotReady": "Die sichere Kartenzahlung für bezahlte Tarife wird im nächsten Schritt aktiviert (Stripe-Testmodus). Ihre Registrierungsdaten sind vollständig und bereit – es wurde nichts abgebucht.",
      "freeCta": "Meinen kostenlosen Eintrag erstellen",
      "paidCta": "Weiter — meine 60 Tage gratis starten",
      "freeName": "Kostenloses Verzeichnis",
      "basicName": "Basic",
      "feat": {
        "free": ["Firmenname", "Kategorie", "Ort", "Basis-Sichtbarkeit im Verzeichnis"],
        "basic": ["Erste 60 Tage gratis", "Vollständige Firmenbeschreibung", "Telefon und Kontaktdaten", "Website und soziale Medien", "Firmenfotos", "Adresse, Karte und Wegbeschreibung", "Standard-Sichtbarkeit in der Suche"],
        "plus": ["Erste 60 Tage gratis", "Alles aus Basic", "Business-Plus-Abzeichen", "Veranstaltungen und Sonderangebote bewerben"]
      }
    },
    "listShare": {
      "today": "Heutiger Einkauf",
      "todayHint": "Dein aktueller Einkauf · Preise vergleichen",
      "myLists": "Meine Listen",
      "noLists": "Erstelle Listen für alles – Lebensmittel, Heimwerken, Brennholz, Haustiere, Garten…",
      "newList": "Neue Liste",
      "namePh": "Listenname (z. B. Wocheneinkauf, Heimwerken, Brennholz)",
      "nameRequired": "Bitte benenne die Liste",
      "kind_personal": "Privat",
      "kind_calendar": "Haushalt",
      "kind_direct": "Geteilt",
      "hintPersonal": "Nur für dich.",
      "hintCalendar": "Mit allen in diesem Kalender geteilt.",
      "hintDirect": "Teile mit bestimmten Personen per E-Mail.",
      "pickCalendar": "Kalender auswählen…",
      "create": "Erstellen",
      "created": "Liste erstellt",
      "rename": "Umbenennen",
      "delListConfirm": "Diese Liste löschen? Ihre Artikel werden entfernt.",
      "share": "Mit jemandem teilen",
      "shared": "Liste geteilt",
      "invite": "Einladen",
      "emailPh": "E-Mail des Find-2-Day-Nutzers",
      "editingShared": "Du arbeitest an einer geteilten Liste",
      "shareHelp": "Eingeladene Personen können diese Liste ansehen und bearbeiten und sehen die Namen und E-Mail-Adressen der anderen, die sie teilen.",
      "remove": "Entfernen",
      "addToWhich": "Hinzufügen zu…",
      "addedToList": "{{n}} zu {{list}} hinzugefügt",
      "addToListN": "Zur Liste hinzufügen ({{n}})",
      "copySelectedToList": "In Liste kopieren ({{n}})",
      "listEmpty": "Noch keine Produkte. Füge hinzu, was du kaufst.",
      "select": "Auswählen",
      "compareThis": "Diese Liste vergleichen",
      "addAll": "Ganze Liste hinzufügen",
      "addSelected": "Ausgewählte hinzufügen ({{n}})",
      "addSelectedShort": "Ausgewählte hinzufügen",
      "addWholeShop": "Ganzen Einkauf hinzufügen",
      "pickItems": "Hake die benötigten Artikel ab",
      "copiedToday": "{{n}} zum Heutigen Einkauf hinzugefügt",
      "itemsN": "{{n}} Artikel",
      "repeatShop": "Letzten Einkauf wiederholen",
      "repeatHint": "Artikel aus deinem letzten Beleg hinzufügen",
      "repeatEmpty": "Kein früherer Einkauf gefunden. Scanne zuerst einen Beleg.",
      "favourite": "Favorit",
      "favAdded": "Zu Favoriten hinzugefügt",
      "favRemoved": "Aus Favoriten entfernt"
    },
    "priceEdit": {
      "title": "Preisdetails", "edit": "Preis bearbeiten", "delete": "Löschen", "save": "Änderungen speichern", "cancel": "Abbrechen",
      "confirmDelete": "Diesen Preis dauerhaft löschen? Dies kann nicht rückgängig gemacht werden.", "confirmYes": "Ja, löschen",
      "productName": "Produktname", "price": "Preis", "brand": "Marke", "packSize": "Packung / Größe", "quantity": "Menge",
      "shop": "Anbieter / Geschäft", "town": "Ort / Standort", "date": "Erfasst am", "notes": "Notizen",
      "notesPh": "z. B. im Angebot, Treuepreis, Großpackung…", "optional": "optional",
      "saved": "Preis aktualisiert", "deleted": "Preis gelöscht",
      "errName": "Bitte einen Produktnamen eingeben", "errPrice": "Bitte einen gültigen Preis eingeben",
      "errSave": "Preis konnte nicht aktualisiert werden", "errDelete": "Preis konnte nicht gelöscht werden"
    },
    "priceHistory": {
      "title": "Preisverlauf", "none": "Noch kein Preisverlauf",
      "noneHint": "Sobald es mehr erfasste Preise für dieses Produkt in diesem Geschäft gibt, erscheint hier ein Trend.",
      "latest": "AKTUELL", "rose": "Preis gestiegen", "fell": "Preis gefallen", "flat": "Etwa gleich"
    },
    "pricePromo": {
      "title": "Price-2-Day Aktionen",
      "subtitle": "Bewirb ein Produktangebot bei Käufern in der Nähe",
      "slots": "Plätze",
      "suspendedNote": "Ihr Unternehmen ist derzeit von Aktionen gesperrt. Bitte kontaktieren Sie den Support.",
      "new": "Neue Aktion",
      "embedTitle": "Meine Aktionen",
      "promoteItem": "Produkt bewerben",
      "boostAgain": "Erneut bewerben",
      "noSlots": "Keine Aktionsplätze übrig. Archivieren Sie eine aktive, um einen Platz freizugeben.",
      "editTitle": "Aktion bearbeiten",
      "createTitle": "Aktion erstellen",
      "product": "Produkt",
      "productPh": "z. B. Olivenöl 2L",
      "brand": "Marke",
      "pack": "Packung / Größe",
      "normalPrice": "Normalpreis",
      "promoPrice": "Aktionspreis",
      "description": "Beschreibung",
      "town": "Ort / Gebiet",
      "branch": "Geschäft / Filiale",
      "optional": "optional",
      "start": "Startdatum",
      "end": "Enddatum",
      "availability": "Verfügbarkeitshinweis",
      "availabilityPh": "z. B. Solange der Vorrat reicht",
      "photo": "Foto",
      "photoError": "Foto konnte nicht hochgeladen werden",
      "save": "Speichern",
      "publish": "Veröffentlichen",
      "updated": "Aktion aktualisiert",
      "published": "Aktion ist jetzt aktiv",
      "submitted": "Aktion zur Prüfung eingereicht",
      "archived": "Aktion archiviert",
      "viewActive": "Aktiv",
      "viewExpired": "Abgelaufen",
      "empty": "Noch keine Aktionen hier.",
      "ends": "endet",
      "sponsored": "Gesponsert",
      "sponsoredHint": "Bezahltes Angebot — nicht Teil des Preisvergleichs",
      "needProduct": "Bitte geben Sie einen Produktnamen ein",
      "needPromoPrice": "Bitte geben Sie einen Aktionspreis ein",
      "needEnd": "Bitte wählen Sie ein Enddatum",
      "saveError": "Aktion konnte nicht gespeichert werden",
      "needDuration": "Bitte wählen Sie eine Aktionsdauer",
      "publishedFree": "Ihre KOSTENLOSE Aktion ist jetzt aktiv",
      "ended": "Aktion beendet",
      "startHint": "leer lassen für heute",
      "duration": "Aktionsdauer",
      "days": "Tage",
      "free": "GRATIS",
      "willEnd": "Endet",
      "testMode": "Vorschau-Testmodus — Preis angezeigt, keine echte Abbuchung",
      "introAvailable": "Ihre erste 7-Tage-Aktion ist KOSTENLOS (eine pro Unternehmen).",
      "introUsed": "Kostenlose Einführungsaktion verwendet.",
      "viewLive": "Aktiv",
      "viewScheduled": "Geplant",
      "edit": "Bearbeiten",
      "endEarly": "Vorzeitig beenden",
      "archive": "Archivieren",
      "status": { "live": "Aktiv", "scheduled": "Geplant", "pending": "In Prüfung", "suspended": "Gesperrt", "expired": "Abgelaufen", "archived": "Archiviert" }
    },
    "price": {
      "tagline": "Scanne einen Kassenbon, um seine Preise zu lesen",
      "homeHeadline": "Gemeinsam Geld sparen",
      "homeTagline": "Echte Preise. Echte Menschen. Eine stärkere Gemeinschaft.",
      "homeIntro": "Scanne deine Kassenbons, teile Preise, vergleiche Geschäfte und hilf allen, die besten Angebote zu finden.",
      "actListTitle": "Meine Einkaufsliste",
      "actListSub": "Was muss ich kaufen?",
      "actSearchTitle": "Günstigsten Preis finden",
      "actSearchSub": "Preise in deiner Nähe vergleichen",
      "actScanTitle": "Preise scannen & teilen",
      "actScanSub": "Die Preise meines Einkaufs hinzufügen",
      "helpTitle": "Deine Kassenbons helfen allen!",
      "helpBody": "Wenn du deinen Kassenbon scannst, verwenden wir nur die Produktinformationen und Preise, um dir und anderen zu helfen, die besten Angebote zu finden.",
      "helpPrivacy": "Wir erfassen und speichern KEINE persönlichen Daten, Zahlungs-/Kartendaten oder das Bild des Kassenbons.",
      "buyOftenTitle": "Was ich oft kaufe",
      "buyOftenSub": "Schnell zu meiner Liste hinzufügen",
      "dealsBtnTitle": "Angebote heute",
      "dealsBtnSub": "Sonderangebote in deiner Nähe",
      "backToMenu": "Zurück",
      "scanWhyTitle": "Hilf allen beim Sparen",
      "scanWhyBody": "Scanne deinen Kassenbon und wir lesen die Preise. Deine Preise helfen dir und anderen in der Gemeinschaft zu sehen, wo Produkte am günstigsten sind.",
      "savedCommunityTitle": "Danke! \u2764\ufe0f",
      "savedCommunityBody": "Deine Preise wurden hinzugefügt. Du hast gerade anderen beim Finden besserer Preise geholfen.",
      "slAddHeading": "Was brauchst du?",
      "quickAddTitle": "Schnell hinzufügen",
      "regularTitle": "Was ich regelmäßig kaufe",
      "addToListBtn": "Hinzufügen",
      "buyOftenEmpty": "Produkte, die du oft kaufst, erscheinen hier – bereit zum Hinzufügen mit einem Tippen.",
      "manageProductsLink": "Meine gespeicherten Produkte verwalten",
      "addedToListToast": "Zu deiner Einkaufsliste hinzugefügt",
      "tabScan": "Scannen",
      "tabSearch": "Suchen",
      "tabFav": "Favoriten",
      "tabDeals": "Angebote",
      "dist": { "pick": "Wähle deinen Ort für Entfernungen", "list": "Liste", "map": "Karte", "soon": "Demnächst", "directions": "Route", "unavailable": "Standort noch nicht verfügbar", "approxTravel": "Ca. Fahrt", "extraTravel": "Ca. Mehrweg", "productSaving": "Produktersparnis", "vsOne": "ggü. Ein Geschäft", "partial": "Einige Standorte noch nicht verfügbar", "nearestNone": "Noch kein zuverlässig verortetes Geschäft für diese Artikel", "knownFor": "Bekannte aktuelle Preise für {{covered}}/{{total}} Artikel" },
      "reviewNote": "Prüfe, was die KI gelesen hat, korrigiere Fehler und speichere. Das Bon-Foto wird nie gespeichert – nur die Preise.",
      "scanTitle": "Kassenbon scannen",
      "scanBlurb": "Fotografiere einen Bon oder wähle einen vom Handy. Funktioniert mit jedem Geschäft und jeder Sprache.",
      "receiptPrivacy": "Beleg-Datenschutz: Ihr Beleg wird ausschließlich verwendet, um Produkt- und Preisinformationen auszulesen. Das Belegbild wird nicht öffentlich angezeigt und von Price-2-Day nicht dauerhaft gespeichert. Persönliche und Zahlungsdaten werden nicht in die Price-2-Day-Preisdatenbank aufgenommen.",
      "signInToScan": "Bitte melde dich an, um einen Beleg zu scannen und zu senden.",
      "signIn": "Anmelden",
      "takePhoto": "Foto aufnehmen",
      "choosePhoto": "Vorhandenes Foto wählen",
      "readingReceipt": "Bon wird gelesen…",
      "receiptPreviewAlt": "Bon-Vorschau",
      "reviewTitle": "Prüfen & korrigieren",
      "reviewSubtitle": "Bearbeite jedes Feld, das die KI falsch gelesen hat.",
      "fShop": "Geschäft",
      "fLocation": "Ort / Filiale",
      "fDate": "Datum",
      "fCurrency": "Währung",
      "fTotal": "Bon-Summe",
      "itemsLabel": "ARTIKEL ({{count}})",
      "noItems": "Keine Positionen erkannt.",
      "itemN": "Artikel {{n}}",
      "removeItem": "Artikel entfernen",
      "fDesc": "Beschreibung (wie gedruckt)",
      "fBrand": "Marke",
      "fPackSize": "Packungsgröße",
      "fQty": "Menge",
      "fUnitPrice": "Stückpreis",
      "fLineTotal": "Zeilensumme",
      "fDiscount": "Rabatt / Angebot",
      "confirmSave": "Preise bestätigen & speichern",
      "saving": "Speichern…",
      "cancel": "Abbrechen",
      "signInHint": "Zum Speichern musst du dich anmelden.",
      "savedTitle": "Bon erfolgreich hinzugefügt",
      "savedBody": "Danke für deinen Beitrag. Du kannst beliebig viele Bons hinzufügen.",
      "scanAnother": "Weiteren Bon scannen",
      "searchPlaceholder": "Produkt suchen, z. B. Olivenöl oder ACEITE",
      "searchBtn": "Suchen",
      "sortLabel": "Sortieren:",
      "sortLowest": "Niedrigster Preis",
      "sortRecent": "Neueste",
      "sortNearest": "Am nächsten",
      "noResults": "Keine passenden Produkte gefunden. Versuche andere Begriffe.",
      "asPrinted": "wie gedruckt",
      "lowestPrice": "Niedrigster Preis",
      "lowestUnit": "Niedrigster Stückpreis",
      "unknownShop": "Unbekanntes Geschäft",
      "shopsCount": "{{count}} Geschäft(e)",
      "receiptDated": "Bon vom",
      "offer": "Angebot",
      "freshRecent": "Aktuell",
      "freshOlder": "Älter",
      "freshHistorical": "Historisch",
      "freshUnknown": "Unbekannt",
      "disclaimer": "Die auf Price-2-Day angezeigten Preise beruhen auf Angaben der Community. Sie können veraltet sein oder je nach Geschäft und Zeit variieren. Prüfe immer im Geschäft vor dem Kauf.",
      "errMin2": "Gib mindestens 2 Zeichen zum Suchen ein.",
      "errHeic": "Dieses Fotoformat konnte nicht gelesen werden. Versuche JPG oder PNG.",
      "errChooseImage": "Bitte wähle ein Bon-Bild.",
      "errNoData": "Es konnten keine Daten extrahiert werden. Versuche ein schärferes Foto.",
      "errScan": "Der Bon konnte nicht gelesen werden. Bitte erneut versuchen.",
      "errNoItems": "Füge vor dem Speichern mindestens einen Artikel mit Beschreibung hinzu.",
      "errSignIn": "Bitte melde dich an, um Bonpreise zu speichern.",
      "errDuplicate": "Du hast diesen Bon bereits eingereicht.",
      "errSaveGeneric": "Speichern nicht möglich. Bitte erneut versuchen.",
      "errSearch": "Suche fehlgeschlagen. Bitte erneut versuchen.",
      "tabProducts": "Meine Produkte",
      "tabList": "Einkaufsliste",
      "signInCta": "Anmelden",
      "errGeneric": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "back": "Zurück",
      "mpSignIn": "Melde dich an, um deine private Liste gekaufter Produkte zu speichern.",
      "mpAddTitle": "Produkt hinzufügen",
      "mpNamePh": "Produktname (z. B. Milch)",
      "mpBrandPh": "Marke (optional)",
      "mpPackPh": "Packungsgröße (optional)",
      "mpAddBtn": "Hinzufügen",
      "mpFromReceipt": "Vom Bon",
      "mpNameRequired": "Bitte einen Produktnamen eingeben.",
      "mpDuplicate": "Dieses Produkt ist bereits in Meine Produkte.",
      "mpAdded": "Zu Meine Produkte hinzugefügt.",
      "mpEmpty": "Noch keine Produkte. Füge hinzu, was du regelmäßig kaufst.",
      "mpToList": "Muss kaufen",
      "mpPickReceipt": "Wähle einen deiner gespeicherten Bons",
      "mpNoReceipts": "Du hast noch keine gespeicherten Bons.",
      "mpTickItems": "Wähle die Artikel für Meine Produkte aus",
      "mpAddSelected": "Auswahl hinzufügen",
      "mpPickOne": "Wähle mindestens einen Artikel.",
      "mpFromReceiptDone": "{{added}} hinzugefügt · {{skipped}} bereits vorhanden",
      "itemsCount": "{{count}} Artikel",
      "status_have": "Genug da",
      "status_low": "Wird knapp",
      "status_need": "Muss kaufen",
      "slSignIn": "Melde dich an, um deine private Einkaufsliste zu speichern.",
      "slAddTitle": "Zur Einkaufsliste hinzufügen",
      "slNamePh": "Artikel eingeben, z. B. Brot",
      "slNameRequired": "Bitte einen Artikel eingeben.",
      "slIncreased": "Menge auf deiner Liste erhöht.",
      "slAdded": "Zu deiner Einkaufsliste hinzugefügt.",
      "slFromProductsHint": "Tipp: Tippe bei einem Produkt in Meine Produkte auf \"Muss kaufen\", um es hier hinzuzufügen.",
      "slEmpty": "Deine Einkaufsliste ist leer.",
      "slTick": "Als gekauft markieren",
      "slUntick": "Zurück zur Liste",
      "slBought": "Gekauft ({{n}})",
      "slClearCompleted": "Erledigte löschen",
      "slCleared": "{{n}} Artikel gelöscht.",
      "buyAgain": "Erneut kaufen",
      "buyAgainDone": "Zu deiner Einkaufsliste hinzugefügt.",
      "addToMyProductsTitle": "Diese zu Meine Produkte hinzufügen?",
      "addToMyProductsBtn": "Auswahl zu Meine Produkte",
      "addedToMyProducts": "Zu Meine Produkte hinzugefügt.",
      "cmpButton": "Meinen Einkauf vergleichen",
      "cmpTitle": "Meinen Einkauf vergleichen",
      "cmpOneShop": "Ein Geschäft",
      "cmpTwoShops": "Zwei Geschäfte",
      "cmpCheapest": "Am günstigsten",
      "cmpNearest": "Am nächsten",
      "cmpEstTotal": "Geschätzte Summe",
      "cmpSaving": "Geschätzte Ersparnis",
      "cmpSubtotal": "Zwischensumme",
      "cmpCoverage": "Preise für {{found}} von {{total}} Artikeln gefunden.",
      "cmpNoRecent": "Kein aktueller Vergleich verfügbar",
      "cmpNoData": "Für diese Option noch keine Preise verfügbar.",
      "cmpDisclaimer": "Geschätzt aus Community-Bonpreisen. Preise können sich geändert haben."
    },
    "notes": {
      "back": "Notizen", "overviewHint": "Private und geteilte Notizen für diesen Kalender.",
      "createNote": "Notiz erstellen", "editNote": "Notiz bearbeiten", "title": "Titel", "text": "Text",
      "textPlaceholder": "Schreibe hier deine Notiz …", "colour": "Farbe", "privacy": "Sichtbarkeit",
      "private": "Privat", "shared": "Geteilt", "privateHint": "Nur du kannst diese Notiz sehen.",
      "sharedHint": "Wähle nach dem Speichern Kalendermitglieder aus, mit denen du sie teilst.",
      "formHint": "Gib deiner Notiz einen Titel und Text. Notizen sind privat, sofern du sie nicht teilst.",
      "save": "Speichern", "cancel": "Abbrechen", "open": "Öffnen", "edit": "Bearbeiten", "delete": "Löschen",
      "copy": "Text kopieren", "share": "Teilen", "manageSharing": "Freigabe verwalten",
      "memberEmail": "E-Mail des Mitglieds",
      "shareDialogHint": "Gib die genaue E-Mail eines Kalendermitglieds ein. Es muss bereits zu diesem Kalender gehören.",
      "noneShared": "Noch mit niemandem geteilt.", "sharedWith": "Geteilt mit", "sharedTag": "mit dir geteilt",
      "readOnly": "Du hast nur Lesezugriff auf diese Notiz.", "empty": "Diese Notiz hat noch keinen Text.",
      "emptyTitle": "Noch keine Notizen", "emptyHint": "Erstelle deine erste private oder geteilte Notiz.",
      "deleteNote": "Notiz löschen",
      "deleteConfirm": "Dadurch wird die Notiz endgültig gelöscht. Das kann nicht rückgängig gemacht werden.",
      "created": "Notiz erstellt", "updated": "Notiz aktualisiert", "deleted": "Notiz gelöscht",
      "copied": "Notiz in die Zwischenablage kopiert",
      "shareCopied": "Teilen hier nicht möglich – Notiz stattdessen kopiert", "shareSaved": "Freigabe aktualisiert",
      "loadError": "Notizen konnten nicht geladen werden", "openError": "Diese Notiz ist nicht verfügbar",
      "saveError": "Notiz konnte nicht gespeichert werden", "deleteError": "Notiz konnte nicht gelöscht werden",
      "copyError": "Notiz konnte nicht kopiert werden", "shareError": "Notiz konnte nicht geteilt werden",
      "shareUpdateError": "Freigabe konnte nicht aktualisiert werden",
      "dragHandle": "Zum Umsortieren ziehen", "reorderHint": "Ziehe eine Notiz am Griff zum Umsortieren oder nutze die ▲ ▼ Pfeile",
      "moveUp": "Nach oben", "moveDown": "Nach unten", "reorderError": "Umsortieren nicht möglich"
    },
    "lists": {
      "back": "Listen", "overviewHint": "Private und geteilte Checklisten für diesen Kalender.",
      "createList": "Liste erstellen", "editList": "Liste bearbeiten", "name": "Name", "colour": "Farbe",
      "privacy": "Sichtbarkeit", "private": "Privat", "shared": "Geteilt",
      "privateHint": "Nur du kannst diese Liste sehen und verwalten.",
      "sharedHint": "Du legst genau fest, welche Kalendermitglieder darauf zugreifen können.",
      "formHint": "Benenne deine Liste, wähle eine Farbe und lege fest, wer sie sehen darf.",
      "save": "Speichern", "cancel": "Abbrechen", "delete": "Löschen", "duplicate": "Duplizieren",
      "editItem": "Eintrag bearbeiten", "deleteList": "Liste löschen",
      "deleteConfirm": "Dadurch werden die Liste und alle Einträge endgültig gelöscht. Das kann nicht rückgängig gemacht werden.",
      "manageSharing": "Freigabe verwalten", "memberEmail": "E-Mail des Mitglieds",
      "shareHint": "Gib die genaue E-Mail eines Kalendermitglieds ein. Es muss bereits zu diesem Kalender gehören.",
      "noneShared": "Noch mit niemandem geteilt.", "sharedWith": "Geteilt mit", "sharedTag": "mit dir geteilt",
      "readOnly": "Du hast nur Lesezugriff auf diese Liste.", "noItems": "Noch keine Einträge.",
      "newItem": "Neuer Eintrag", "itemText": "Eintrag", "itemPlaceholder": "z. B. Milch",
      "quantity": "Menge", "qty": "Anz.", "done": "erledigt", "emptyTitle": "Noch keine Listen",
      "emptyHint": "Erstelle deine erste private oder geteilte Liste.", "dragHandle": "Zum Umsortieren ziehen",
      "reorderHint": "Ziehe am Griff zum Umsortieren oder nutze die ▲ ▼ Pfeile", "reorderListsHint": "Ziehe eine Liste am Griff, um sie umzusortieren",
      "itemTextRequired": "Eintragstext ist erforderlich", "created": "Liste erstellt", "updated": "Liste aktualisiert",
      "deleted": "Liste gelöscht", "duplicated": "Eine private Kopie wurde erstellt", "itemUpdated": "Eintrag aktualisiert",
      "loadError": "Listen konnten nicht geladen werden", "openError": "Diese Liste ist nicht verfügbar",
      "saveError": "Liste konnte nicht gespeichert werden", "deleteError": "Liste konnte nicht gelöscht werden",
      "dupError": "Liste konnte nicht dupliziert werden", "itemError": "Eintrag konnte nicht hinzugefügt werden",
      "itemError2": "Eintrag konnte nicht aktualisiert werden", "itemDelError": "Eintrag konnte nicht gelöscht werden",
      "reorderError": "Reihenfolge konnte nicht geändert werden", "shareSaved": "Freigabe aktualisiert",
      "shareError": "Freigabe konnte nicht aktualisiert werden"
    },
    "bookingCal": {
      "repeat": "Wiederholung", "repeatEditHint": "ändern, wie sich diese Buchung wiederholt",
      "repeatNone": "Keine Wiederholung", "repeatDaily": "Täglich", "repeatWeekly": "Wöchentlich",
      "repeatBiweekly": "Alle 2 Wochen", "repeatMonthly": "Monatlich", "repeatCustom": "Benutzerdefiniert",
      "endDateRequired": "Bitte wähle ein Enddatum für die Wiederholung",
      "repeatUpdated": "Wiederholung aktualisiert – {n} Buchungen", "repeatRemoved": "Diese Buchung wiederholt sich nicht mehr",
      "savedEdit": "Buchung aktualisiert", "savedDupGroup": "Alle duplizierten Buchungen aktualisiert",
      "deleted": "Buchung in den Papierkorb verschoben", "skipDate": "Diesen Termin überspringen",
      "skipDateQ": "Diesen Termin überspringen?",
      "skipDateDesc": "Nur {date} wird entfernt. Die restliche Serie bleibt unverändert. Du kannst ihn später aus dem Papierkorb wiederherstellen.",
      "dateSkipped": "Dieser Termin wurde übersprungen – die restliche Wiederholung bleibt unverändert",
      "repeatsPrefix": "Wiederholt sich", "recEveryDay": "täglich", "recEveryNDays": "alle {n} Tage",
      "recEveryWeek": "wöchentlich", "recEvery2Weeks": "alle 2 Wochen", "recEveryNWeeks": "alle {n} Wochen",
      "recOn": "am", "recMonthly": "monatlich", "recEveryNMonths": "alle {n} Monate", "recUntil": "bis {d}",
      "recForN": "für {n} Termine", "repeats": "Wiederkehrende Buchung", "repeatsShort": "Wiederholt sich",
      "dupDelTitle": "Duplizierte Buchung löschen",
      "dupDelIntro": "Diese Buchung ist eine von {n}, die gemeinsam über Duplizieren erstellt wurden.",
      "dupDelThis": "Nur diese Buchung löschen", "dupDelAll": "Alle duplizierten Buchungen löschen",
      "dupDelAllGo": "Alle löschen", "dupDelSelect": "Buchungen zum Löschen auswählen",
      "dupDelSelectedGo": "Ausgewählte löschen",
      "dupDelAllConfirm": "Alle {n} duplizierten Buchungen löschen? Sie werden in den Papierkorb verschoben.",
      "dupDelPickOne": "Bitte wähle mindestens eine Buchung aus.", "dupDelDone": "{n} Buchung(en) gelöscht",
      "dupDelPartial": "{ok} gelöscht; {fail} fehlgeschlagen",
      "dupDelFailed": "Die duplizierten Buchungen konnten nicht gelöscht werden",
      "listsNav": "Listen", "notesNav": "Notizen"
    },
    "eventCreateFailed": "Veranstaltung konnte nicht erstellt werden. Bitte versuche es erneut.",
    "eventUpdateFailed": "Veranstaltung konnte nicht aktualisiert werden. Bitte versuche es erneut.",
    "eventsBlockedTrialEnded": "Deine Testphase ist beendet. Füge eine Zahlungsmethode hinzu, um wieder Veranstaltungen zu veröffentlichen.",
    "eventsBlockedPlan": "Dein aktueller Tarif beinhaltet keine Veranstaltungen. Führe ein Upgrade durch, um Veranstaltungen zu posten.",
    "eventsBlockedMax": "Du hast dein Limit von {{max}} aktiven Veranstaltungen erreicht. Archiviere eine Veranstaltung unten oder wechsle zu Featured für mehr.",
    "eventsActiveHint": "Aktiv = nur laufende und kommende Veranstaltungen. Vergangene/abgelaufene Veranstaltungen zählen nicht zu deinem Limit.",
    "home": {
      "heroTagline": "Alles, was in deiner Stadt passiert.",
      "startCardTitle": "Start",
      "startCardDesc": "Entdecke alles, was in deiner Stadt passiert.",
      "businessCardTitle": "Unternehmen",
      "businessCardDesc": "Bewirb dein Unternehmen, deine Organisation oder Gemeinschaftsgruppe.",
      "discoverTitle": "Geschäfte & Events entdecken",
      "localAlertsTitle": "Community-Sicherheitszentrum",
      "classifiedsTitle": "Verkaufen · Verloren · Gefunden",
      "bankHolidaysTitle": "Feiertage",
      "emergencyTitle": "Notrufnummern",
      "businessSignInTitle": "Hast du schon ein Geschäftskonto? Anmelden",
      "businessCalendarTitle": "Geschäftskalender"
    },
    "frontpage": {
      "claimExistingBusinessTitle": "Geschäft beanspruchen oder hinzufügen",
      "charityApplyTitle": "Gemeinde- / Wohltätigkeitseintrag"
    },
    "frontpageEarnCommission": "Community-Partner werden",
    "dismiss": "Schließen",
    "safetyOptInTitle": "Verpasse keine Sicherheitsmeldung",
    "safetyOptInBody": "Erhalte offizielle Sicherheitsmeldungen direkt auf dein Handy, damit du nie wichtige Informationen aus deiner Gemeinde verpasst.",
    "safetyOptInCta": "Handy-Benachrichtigungen aktivieren",
    "safetyOptInEnabling": "Wird aktiviert…",
    "safetyOptInError": "Benachrichtigungen konnten nicht aktiviert werden. Bitte versuche es erneut.",
    "appTitle": "Find-2-day",
    "appBadgeTitle": "Benachrichtigungen auf dem Handy",
    "appBadgeDesc": "Zeigt ein Symbol-Badge und eine Benachrichtigung, wenn eine neue Sicherheitsmeldung eintrifft — auch wenn die App geschlossen ist.",
    "appBadgeUnsupported": "Auf diesem Gerät nicht unterstützt",
    "appBadgeEnabled": "Handy-Benachrichtigungen aktiv. Installiere Find-2-Day auf dem Startbildschirm für das Symbol-Badge.",
    "appBadgeFallback": "Dein Gerät zeigt Benachrichtigungen, aber kein Symbol-Badge — du erhältst weiterhin die In-App-Glockenanzeige.",
    "appTagline": "Finde lokale Geschäfte, Erlebnisse, Events und Aktivitäten in deiner Nähe",
    "getStarted": "Loslegen",
    "listYourBusiness": "Dein Geschäft eintragen",
    "signIn": "Anmelden",
    "joinBusiness": "Als Unternehmen beitreten",
    "categories": {
      "food": "Essen & Gastronomie",
      "music": "Musik & Nachtleben",
      "family": "Familienaktivitäten",
      "offers": "Sonderangebote",
      "wellbeing": "Wellness & mehr"
    },
    "nav": {
      "discover": "Entdecken",
      "favorites": "Favoriten",
      "events": "Events",
      "offers": "Angebote",
      "profile": "Profil",
      "forSale": "Verkaufen / Verloren / Gefunden",
      "communityHub": "Community"
    },
    "welcomeBack": "Willkommen zurück!",
    "signInSubtitle": "Melde dich an, um weiterzustöbern",
    "emailOrUsername": "E-Mail",
    "password": "Passwort",
    "rememberMe": "Angemeldet bleiben",
    "forgotPassword": "Passwort vergessen?",
    "forgotPasswordTitle": "Passwort vergessen?",
    "forgotPasswordDesc": "Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen.",
    "forgotPasswordError": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    "sendResetLink": "Link senden",
    "sending": "Wird gesendet...",
    "checkYourEmail": "Prüfe deine E-Mails",
    "resetEmailSent": "Falls ein Konto existiert, haben wir einen Link zum Zurücksetzen gesendet. Prüfe Posteingang und Spam.",
    "backToSignIn": "Zurück zur Anmeldung",
    "setNewPassword": "Neues Passwort festlegen",
    "setNewPasswordDesc": "Wähle ein sicheres Passwort mit mindestens 6 Zeichen.",
    "newPassword": "Neues Passwort",
    "confirmPassword": "Passwort bestätigen",
    "resetPassword": "Passwort zurücksetzen",
    "resetting": "Wird zurückgesetzt...",
    "passwordReset": "Passwort zurückgesetzt",
    "passwordResetSuccess": "Dein Passwort wurde erfolgreich zurückgesetzt.",
    "invalidResetLink": "Ungültiger Link",
    "invalidResetLinkDesc": "Dieser Link ist ungültig oder abgelaufen.",
    "requestNewLink": "Neuen Link anfordern",
    "passwordMinLength": "Passwort muss mindestens 6 Zeichen haben",
    "passwordsMustMatch": "Passwörter stimmen nicht überein",
    "emailAddress": "E-Mail-Adresse",
    "dontHaveAccount": "Noch kein Konto?",
    "signUp": "Registrieren",
    "businessSignUp": "Geschäft registrieren",
    "joinAsBusinessTitle": "Als Unternehmen beitreten",
    "freeTrialOffer": "Starte sofort mit deinem Eintrag",
    "accountInformation": "Kontoinformationen",
    "fullName": "Vollständiger Name",
    "email": "E-Mail",
    "businessInformation": "Geschäftsinformationen",
    "businessName": "Geschäftsname",
    "description": "Beschreibung",
    "tellUsAbout": "Erzähle uns von deinem Geschäft...",
    "continue": "Weiter",
    "fullNamePlaceholder": "Max Mustermann",
    "passwordPlaceholder": "Sicheres Passwort erstellen",
    "businessNamePlaceholder": "Dein Geschäftsname",
    "stepOf": "Schritt {{step}} von {{total}}",
    "allFieldsRequired": "Alle Felder sind erforderlich",
    "businessNameDescRequired": "Geschäftsname und Beschreibung erforderlich",
    "fillAllRequired": "Bitte alle Pflichtfelder ausfüllen",
    "specifyCategoryOther": "Bitte Kategorie angeben",
    "selectPlanRequired": "Bitte einen Plan auswählen",
    "registrationFailed": "Registrierung fehlgeschlagen. Bitte versuche es erneut.",
    "emailAlreadyRegistered": "Diese E-Mail ist bereits registriert.",
    "contactLocation": "Kontakt & Standort",
    "categoryLabel": "Kategorie",
    "selectCategory": "Kategorie wählen",
    "specifyCategory": "Kategorie angeben",
    "specifyCategoryPlaceholder": "z.B. Hundepflege",
    "cityLabel": "Stadt",
    "businessAddress": "Geschäftsadresse",
    "addressPlaceholder": "Hauptstraße 123, 28001 Madrid",
    "addressTip": "Tipp: Suche dein Geschäft auf Google Maps und kopiere die vollständige Adresse",
    "phoneNumber": "Telefonnummer",
    "businessEmailLabel": "Geschäfts-E-Mail",
    "websiteLabel": "Webseite",
    "openingHoursLabel": "Öffnungszeiten",
    "whatDoesOffer": "Was bietet dein Geschäft?",
    "selectAllApply": "Wähle alle zutreffenden aus",
    "groupSizeLabel": "Gruppengrößen",
    "eventTypesLabel": "Eventtypen",
    "venueTypeLabel": "Veranstaltungsort",
    "dietaryOptionsLabel": "Ernährungsoptionen",
    "additionalFeaturesTitle": "Zusätzliche Funktionen",
    "specialFeatures": "Besondere Merkmale",
    "accessibilityFacilities": "Barrierefreiheit",
    "chooseYourPlan": "Wähle deinen Plan",
    "planSubtitle": "Wähle ein Abo. Dein Eintrag geht live, sobald die Zahlung bestätigt ist.",
    "perMonth": "Monat",
    "plusIVA": "MwSt. inklusive",
    "bestValue": "Bester Preis",
    "selected": "Ausgewählt",
    "freeTrialTitle": "Sofort listen",
    "freeTrialDesc": "Einmal zahlen — dein Eintrag geht live, sobald die Zahlung bestätigt ist. Alle Preise inkl. 21% MwSt. Jederzeit kündbar.",
    "settingUp": "Wird eingerichtet...",
    "proceedToPayment": "Zur Zahlung",
    "alreadyHaveAccount": "Bereits ein Konto?",
    "selectDaysHours": "Tage und Zeiten auswählen",
    "timeTo": "bis",
    "closed": "Geschlossen",
    "dayMonday": "Montag",
    "dayTuesday": "Dienstag",
    "dayWednesday": "Mittwoch",
    "dayThursday": "Donnerstag",
    "dayFriday": "Freitag",
    "daySaturday": "Samstag",
    "daySunday": "Sonntag",
    "plan6months": "6 Monate",
    "plan12months": "Best Setup / Voller Zugang",
    "featured": "Empfohlen",
    "findAmazing": "Finde tolle Erlebnisse in deiner Nähe",
    "searchPlaceholder": "Geschäfte suchen...",
    "logout": "Abmelden",
    "all": "Alle",
    "pendingTab": "Ausstehend",
    "callNow": "Jetzt anrufen",
    "emailButton": "E-Mail",
    "openingHours": "Öffnungszeiten",
    "pendingApprovalTitle": "Wartet auf Genehmigung",
    "pendingApprovalDesc": "Dein Geschäft wird von unserem Team geprüft",
    "trialDaysRemaining": "{{days}} Tag(e) verbleibend",
    "businessVisible": "Dein Geschäft ist für Nutzer sichtbar",
    "subscriptionActive": "Abo aktiv",
    "subscriptionExpired": "Abo abgelaufen",
    "subscriptionExpiredDesc": "Dein Eintrag ist versteckt. Abonniere um zu reaktivieren.",
    "noPhotosDesc": "Noch keine Fotos. Füge bis zu 5 Fotos hinzu.",
    "businessAccount": "Geschäftskonto",
    "regularAccount": "Benutzerkonto",
    "activeFilters": "Aktive Filter",
    "noBusinessesFound": "Keine Geschäfte gefunden.",
    "tryDifferentFilters": "Versuche andere Filter oder Suchbegriffe.",
    "businessesWillAppear": "Geschäfte erscheinen hier nach Admin-Genehmigung.",
    "clearFilters": "Filter löschen",
    "businessFound": "Geschäft gefunden",
    "businessesFound": "Geschäfte gefunden",
    "filters": "Filter",
    "resetAll": "Alles zurücksetzen",
    "applyFilters": "Filter anwenden",
    "settings": "Einstellungen",
    "preferences": "Einstellungen",
    "language": "Sprache",
    "notifications": "Benachrichtigungen",
    "darkMode": "Dunkelmodus",
    "comingSoon": "Bald verfügbar",
    "account": "Konto",
    "privacySecurity": "Datenschutz & Sicherheit",
    "support": "Hilfe",
    "helpCenter": "Hilfecenter",
    "aboutApp": "Über Find-2-Day",
    "noEventsYet": "Noch keine Events",
    "eventsWillAppear": "Events lokaler Geschäfte erscheinen hier bald!",
    "browseBusinesses": "Geschäfte durchsuchen",
    "noOffersYet": "Noch keine Angebote",
    "offersWillAppear": "Schau bald wieder vorbei für tolle Angebote!",
    "noFavoritesYet": "Noch keine Favoriten",
    "startExploring": "Beginne Geschäfte zu erkunden und speichere deine Favoriten!",
    "discoverBusinesses": "Geschäfte entdecken",
    "save": "Speichern",
    "saved": "Gespeichert",
    "cancel": "Abbrechen",
    "consentText": "Ich stimme den",
    "consentAnd": "und",
    "consentRequired": "Du musst den AGB und Datenschutzrichtlinien zustimmen",
    "termsAndConditions": "AGB",
    "privacyPolicyTitle": "Datenschutzrichtlinie",
    "date": "Datum", "pickDate": "Datum wählen",
    "back": "Zurück",
    "submit": "Absenden",
    "or": "oder",
    "loading": "Laden...",
    "error": "Fehler",
    "success": "Erfolg",
    "goBack": "Zurück",
    "goHome": "Startseite",
    "admin": "Admin",
    "terms": "AGB",
    "privacy": "Datenschutz",
    "cookies": "Cookies",
    "createAccount": "Konto erstellen",
    "creatingAccount": "Konto wird erstellt...",
    "about": "Über",
    "share": "Teilen",
    "copyLink": "Link kopieren",
    "linkCopied": "Kopiert!",
    "shareMore": "Mehr",
    "shareDefaultText": "Schau dir diesen Eintrag auf Find-2-Day an!",
    "reviews": "Bewertungen",
    "writeReview": "Bewertung schreiben",
    "yourRating": "Deine Bewertung",
    "yourReview": "Deine Bewertung",
    "reviewPlaceholder": "Teile deine Erfahrung (min. 10 Zeichen)...",
    "submitReview": "Bewertung absenden",
    "noReviewsYet": "Noch keine Bewertungen. Sei der Erste!",
    "loginToReview": "Melde dich an, um eine Bewertung zu schreiben",
    "favourite": "Speichern",
    "favourited": "Gespeichert",
    "followAlerts": "Benachrichtigungen",
    "following": "Aktiv",
    "resetFilters": "Filter zurücksetzen",
    "offers": "Angebote",
    "activeOffers": "aktive Angebote",
    "upcomingEvents": "kommende Events",
    "daysLeft": "Tage übrig",
    "showingOf": "Zeige {{from}}-{{to}} von {{total}}",
    "manageBilling": "Abrechnung verwalten",
    "manageSubscription": "Abo verwalten",
    "manageSubscriptionDesc": "Zahlungsmethoden aktualisieren, Rechnungen einsehen, Plan ändern.",
    "onboardingTitle": "Willkommen bei Find-2-Day!",
    "onboardingStep1Title": "Lokale Einträge entdecken",
    "onboardingStep1Desc": "Durchsuche Geschäfte, Vereine, Events und Angebote in deiner Nähe.",
    "onboardingStep2Title": "Favoriten speichern",
    "onboardingStep2Desc": "Tippe auf das Herz, um Einträge zu speichern und sie schnell wiederzufinden.",
    "onboardingStep3Title": "Benachrichtigungen erhalten",
    "onboardingStep3Desc": "Tippe auf 'Benachrichtigungen' bei jedem Eintrag, um Updates zu erhalten.",
    "onboardingGotIt": "Verstanden!",
    "onboardingNext": "Weiter",
    "onboardingSkip": "Überspringen",
    "locationPicker": {
      "title": "Erhalte Meldungen für deine Region",
      "intro": "Wähle deinen Ort in Almería, damit wir dir Events, Angebote und Sicherheitsmeldungen in der Nähe senden können.",
      "homeTownLabel": "Dein Ort oder Dorf",
      "searchPlaceholder": "Almería-Orte durchsuchen…",
      "noTowns": "Keine passenden Orte gefunden.",
      "nearbyLabel": "Auch nahegelegene Orte melden",
      "nearbyHint": "Im Umkreis von {{km}} km. Bei Bedarf anpassen.",
      "radiusAria": "Umkreis in Kilometern",
      "regionLabel": "Meldungen für ganz Almería",
      "regionHint": "Provinzweite Events, große Angebote und Sicherheitsmeldungen.",
      "followedTownsLabel": "Weitere Orte folgen (optional)",
      "followedTownsHint": "Wähle zusätzliche Orte neben deinem Heimatort.",
      "followedTownsAddPlaceholder": "Ort hinzufügen…",
      "removeTown": "Entfernen",
      "skip": "Jetzt nicht",
      "save": "Meine Region speichern",
      "saving": "Speichern…"
    },
    "categoryFood": "Essen & Trinken",
    "categoryMusic": "Musik & Nachtleben",
    "categoryShopping": "Einkaufen",
    "categoryHealthWellness": "Gesundheit & Wellness",
    "categoryEvents": "Events & Unterhaltung",
    "categoryEducation": "Bildung",
    "categoryHomeServices": "Haushaltsservices",
    "categoryTravel": "Reisen & Tourismus",
    "categoryBeautySpa": "Beauty & Spa",
    "categorySports": "Sport & Fitness",
    "categoryArts": "Kunst & Kultur",
    "categoryProfessional": "Professionelle Dienste",
    "categoryAutomotive": "Automobil",
    "categoryTechnology": "Technologie",
    "categoryVets": "Tierärzte",
    "categoryVolunteerWork": "Ehrenamt",
    "categoryJobs": "Stellenangebote",
    "categoryCommunityHelp": "Gemeinschaftshilfe",
    "categoryCommunity": "Gemeinschaft",
    "categoryOther": "Sonstiges",
    "pwaInstallTitle": "Find-2-Day installieren",
    "pwaInstallDesc": "Vollständige App-Erfahrung mit Benachrichtigungen",
    "pwaInstallBtn": "Installieren",
    "whatsNew_title": "Neuigkeiten",
    "whatsNew_item1": "Sofortige Benachrichtigungen von deinen Lieblingsgeschäften — neue Veranstaltungen, Angebote und mehr",
    "whatsNew_item2": "Funktioniert auf allen Geräten — Push-Benachrichtigungen plus E-Mail als Ausweich",
    "whatsNew_cta": "Benachrichtigungen für Events & Angebote",

    // Classifieds
    "marketplace": {
      "tabSell": "Verkaufen", "tabWanted": "Gesucht", "tabSwap": "Tausch", "tabFree": "Gratis",
      "hintMarketTitle": "Kaufen, verkaufen, tauschen oder verschenken",
      "swapTitle": "SWAP-2-DAY", "swapSubtitle": "Was hast du? Wogegen würdest du es tauschen?",
      "swapLabel": "Tausch", "orSwap": "ODER TAUSCH"
    },
    "swap": {
      "moneyNone": "Keine", "moneyBtoA": "Anbieter zahlt Eigentümer €{n}", "moneyAtoB": "Eigentümer zahlt Anbieter €{n}",
      "ownerProvides": "Eigentümer gibt", "offererProvides": "Anbieter gibt", "money": "Zusätzliches Geld",
      "negotiation": "Tauschverhandlung", "youAre": "Du bist der/die", "owner": "Anzeigeninhaber:in", "offerer": "anbietende Person",
      "agreed": "TAUSCH VEREINBART", "agreedAt": "Vereinbart am", "finalTerms": "Endgültig vereinbarte Bedingungen", "currentTerms": "Aktuelle Bedingungen",
      "confirmed": "bestätigt ✓", "notConfirmed": "noch nicht", "ownerLabel": "Eigentümer", "offererLabel": "Anbieter",
      "iAgree": "Ich stimme diesem Tausch zu", "youConfirmed": "Du hast bestätigt – warte auf die andere Person",
      "counter": "Gegenangebot", "decline": "Ablehnen", "withdraw": "Mein Angebot zurückziehen", "cancel": "Diese Verhandlung abbrechen",
      "history": "Angebotsverlauf", "makeCounter": "Gegenangebot machen", "commaSep": "durch Kommas getrennt",
      "moneyAmount": "Geld (€)", "moneyDir": "Zahlungsrichtung", "dirNone": "Kein Geld", "dirBtoA": "Anbieter zahlt Eigentümer", "dirAtoB": "Eigentümer zahlt Anbieter",
      "notePlaceholder": "Optionale Notiz…", "sendCounter": "Gegenangebot senden", "backToMarket": "Zurück zum Marktplatz",
      "loadFail": "Dieser Tausch konnte nicht geladen werden.", "actionFail": "Aktion fehlgeschlagen.",
      "ownerGives": "Der Eigentümer gibt", "describeYours": "Beschreibe, was du im Tausch geben würdest (du kannst auch Geld hinzufügen).",
      "itemsPlaceholder": "z. B. Rasenmäher, Trimmer (durch Kommas getrennt)", "sendOffer": "Tauschangebot senden", "createFail": "Angebot konnte nicht gesendet werden.",
      "errName": "Bitte gib deinen Namen ein.", "errEmail": "Bitte gib eine gültige E-Mail-Adresse ein.", "errItems": "Beschreibe mindestens einen Artikel, den du anbietest."
    },
    "classifieds": {
      "listingType": "Anzeigentyp", "typeSellOnly": "Nur verkaufen", "typeSwapOnly": "Nur tauschen", "typeSellOrSwap": "Verkaufen oder tauschen", "typeFree": "Gratis", "typeWanted": "Gesucht",
      "swapWantedTitle": "Was möchtest du im Tausch?", "swapAddOwn": "Eigenes hinzufügen…", "openToOffers": "Offen für Angebote",
      "swapPrefsHint": "Dies sind nur Wünsche – andere dürfen auch etwas anderes anbieten.", "sellSwapPriceHint": "Käufer können zu diesem Preis kaufen ODER ein Tauschangebot machen.",
      "errSellSwapPrice": "Bitte gib einen Verkaufspreis für eine „Verkaufen oder tauschen“-Anzeige ein",
      "buyFor": "Kaufen für", "swapWantedShort": "Tausch gesucht", "swapOpenAny": "offen für Ideen", "otherOffersConsidered": "Andere Angebote werden berücksichtigt",
      "contactToBuy": "Zum Kaufen kontaktieren", "makeSwapOffer": "Tauschangebot machen", "statusSwapped": "Getauscht!",
      "swappedNote": "Getauschte Anzeigen sind aus der Suche ausgeblendet. Dein Eintrag bleibt für dich erhalten.",
      "editTypePrice": "Anzeigentyp / Preis ändern (z. B. Artikel auch verkaufen)", "editSwapNote": "Käufer sehen „€… ODER TAUSCH“ und können ein Tauschangebot machen. Deine Fotos, Beschreibung und Anzeigen-ID bleiben gleich.",
      "offersReceived": "Erhaltene Tauschangebote", "noOffersYet": "Noch keine Tauschangebote.", "errSave": "Änderungen konnten nicht gespeichert werden.",
      "title": "Verkaufen / Verloren / Gefunden",
      "sellTab": "Verkaufen",
      "hintCardTitle": "Wo soll ich das einstellen?",
      "hintCardSell": "Einen Artikel verkaufen",
      "hintCardSellDesc": "Nutze den Reiter Verkaufen",
      "hintCardLostFound": "Etwas verloren oder gefunden",
      "hintCardLostFoundDesc": "Nutze den Reiter Verloren & Gefunden",
      "hintCardPetSafety": "Haustier vermisst oder Sicherheitsanliegen",
      "hintCardPetSafetyDesc": "Nutze das Community-Sicherheitszentrum",
      "searchPlaceholder": "Artikel suchen...",
      "postItem": "Artikel einstellen",
      "noItems": "Keine Artikel gefunden",
      "tryDifferent": "Versuche andere Suchbegriffe oder Filter",
      "beFirst": "Sei der Erste, der etwas zum Verkauf anbietet!",
      "itemFound": "Artikel",
      "itemsFound": "Artikel",
      "negotiable": "Verhandelbar",
      "sold": "Verkauft",
      "description": "Beschreibung",
      "contactSeller": "Verkäufer kontaktieren",
      "expiresOn": "Diese Anzeige läuft ab am",
      "ownerActions": "Du hast Eigentümerzugang zu dieser Anzeige.",
      "markSold": "Als verkauft markieren",
      "delete": "Löschen",
      "deleteListing": "Anzeige löschen",
      "alreadySold": "Dieser Artikel wurde als verkauft markiert.",
      "confirmSold": "Als verkauft markieren?",
      "confirmSoldDesc": "Die Anzeige wird als verkauft markiert.",
      "confirmDelete": "Anzeige löschen?",
      "confirmDeleteDesc": "Die Anzeige wird dauerhaft gelöscht.",
      "yesSold": "Ja, verkauft",
      "yesDelete": "Ja, löschen",
      "marking": "Wird markiert...",
      "deleting": "Wird gelöscht...",
      "errorMarkSold": "Konnte nicht als verkauft markiert werden.",
      "errorDelete": "Konnte nicht gelöscht werden.",
      "posted": "Artikel eingestellt!",
      "postedDesc": "Deine Anzeige ist jetzt aktiv. Sie läuft nach 30 Tagen automatisch ab.",
      "saveLink": "Speichere diesen Link um deine Anzeige zu verwalten:",
      "viewListing": "Anzeige ansehen",
      "browseMore": "Mehr durchsuchen",
      "photos": "Fotos",
      "itemTitle": "Titel",
      "titlePlaceholder": "Was verkaufst du?",
      "category": "Kategorie",
      "price": "Preis",
      "optional": "optional",
      "priceHint": "Leer lassen für \"Verhandelbar\"",
      "descLabel": "Beschreibung",
      "descPlaceholder": "Beschreibe den Artikel, Zustand, Funktionen...",
      "location": "Standort",
      "locationPlaceholder": "z.B. Almería Centro, Retamar...",
      "contactInfo": "Deine Kontaktdaten",
      "yourName": "Name",
      "namePlaceholder": "Dein Name",
      "yourEmail": "E-Mail",
      "emailPlaceholder": "deine@email.de",
      "yourPhone": "Telefon",
      "addPhoto": "Hinzufügen",
      "maxPhotos": "Maximal 6 Fotos erlaubt",
      "errTitle": "Titel muss mindestens 3 Zeichen haben",
      "errDesc": "Beschreibung muss mindestens 10 Zeichen haben",
      "errCategory": "Bitte Kategorie auswählen",
      "errName": "Bitte Name eingeben",
      "errEmail": "Bitte gültige E-Mail eingeben",
      "errLocation": "Bitte Standort eingeben",
      "errSubmit": "Fehler beim Einstellen. Bitte erneut versuchen.",
      "posting": "Wird eingestellt...",
      "postForFree": "Kostenlos einstellen",
      "autoExpire": "Anzeigen laufen nach 30 Tagen automatisch ab",
      "cat": {
        "Tools": "Werkzeuge",
        "Furniture": "Möbel",
        "Cars & Vehicles": "Autos & Fahrzeuge",
        "Electronics": "Elektronik",
        "Property": "Immobilien",
        "Clothing & Fashion": "Kleidung & Mode",
        "Home & Garden": "Haus & Garten",
        "Sports & Leisure": "Sport & Freizeit",
        "Baby & Kids": "Baby & Kinder",
        "General": "Allgemein"
      },
      "statusAvailable": "Verfügbar",
      "statusPending": "Abholung ausstehend",
      "statusSold": "Verkauft",
      "changeStatus": "Status ändern",
      "soldAutoRemove": "Verkaufte Anzeigen werden nach 3 Tagen automatisch entfernt.",
      "errorStatus": "Status konnte nicht aktualisiert werden.",
      "emailSent": "Verwaltungslink an deine E-Mail gesendet",
      "emailSentDesc": "Prüfe deinen Posteingang für den Link zum Bearbeiten oder Löschen.",
      "manageHelp": "Mit deinem Verwaltungslink kannst du:",
      "manageEdit": "Anzeigendetails bearbeiten",
      "managePending": "Status auf 'Abholung ausstehend' setzen",
      "manageSold": "Als Verkauft markieren (nach 3 Tagen ausgeblendet)",
      "manageDelete": "Die Anzeige löschen",
      "manageListing": "Anzeige verwalten",
      "manageYourListing": "Deine Anzeige verwalten",
      "resendLink": "Verwaltungslink verloren?",
      "resendTitle": "Verwaltungslinks erhalten",
      "resendDesc": "Gib die E-Mail ein, die du beim Einstellen verwendet hast.",
      "resendEmailPlaceholder": "deine@email.de",
      "resendBtn": "Senden",
      "resendSent": "Prüfe dein Postfach!",
      "resendSentDesc": "Falls aktive Anzeigen existieren, haben wir die Verwaltungslinks gesendet.",
      "resendErrEmail": "Bitte gültige E-Mail eingeben",
      "resendError": "Etwas ist schiefgelaufen. Bitte erneut versuchen."
    },
    "nearestMe": {
      "button": "In der Nähe",
      "notSupported": "Geolokalisierung wird von deinem Browser nicht unterstützt",
      "denied": "Standortzugriff verweigert. Du kannst nach Stadt suchen.",
      "error": "Standort konnte nicht ermittelt werden. Erneut versuchen.",
      "townPlaceholder": "Ort eingeben, z. B. Lyon, Frankreich",
      "useTown": "Ort verwenden",
      "townNotFound": "Ort nicht gefunden. Versuche eine größere Stadt in der Nähe oder füge das Land hinzu."
    },
    "lostFound": {
      "title": "Fundbüro",
      "searchPlaceholder": "Verlorene & gefundene Gegenstände suchen...",
      "postItem": "Verlorenen/Gefundenen Gegenstand melden",
      "noItems": "Keine Gegenstände gefunden",
      "beFirst": "Melde einen verlorenen oder gefundenen Gegenstand.",
      "lost": "Verloren", "found": "Gefunden", "lostOn": "Verloren", "foundOn": "Gefunden",
      "resolved": "Erledigt", "markResolved": "Als erledigt markieren", "contactPerson": "Kontakt",
      "typeLabel": "Ist der Gegenstand verloren oder gefunden?",
      "iLostSomething": "Ich habe etwas verloren", "iFoundSomething": "Ich habe etwas gefunden",
      "itemTitle": "Was wurde verloren/gefunden?",
      "titlePlaceholder": "z.B. Kleiner brauner Hund, Autoschlüssel...",
      "category": "Kategorie", "dateLost": "Verloren am", "dateFound": "Gefunden am",
      "descPlaceholder": "Beschreibe den Gegenstand, wo er verloren/gefunden wurde...",
      "locationLabel": "Gegend / Ort", "locationPlaceholder": "z.B. Almería Centro, Retamar...",
      "posted": "Gemeldet!", "postedDesc": "Dein Eintrag ist aktiv. Er läuft nach 30 Tagen ab.",
      "viewItem": "Eintrag ansehen", "browseMore": "Mehr durchsuchen", "postForFree": "Kostenlos melden",
      "cat": { "Pets": "Haustiere", "Keys": "Schlüssel", "Wallets/Bags": "Geldbörsen/Taschen", "Documents/ID": "Dokumente/Ausweis", "Phones/Electronics": "Telefone/Elektronik", "Other": "Sonstiges" }
    },
    "savedSearch": {
      "setAlert": "Suchalarm einrichten",
      "title": "Suchalarm",
      "desc": "Werde benachrichtigt, wenn neue Artikel deiner Suche entsprechen.",
      "queryPlaceholder": "z.B. Sofa, Fahrrad, iPhone...",
      "anyCategory": "Jede Kategorie",
      "emailPlaceholder": "Deine E-Mail für Benachrichtigungen",
      "save": "Alarm speichern",
      "saving": "Wird gespeichert...",
      "saved": "Alarm gespeichert!",
      "savedDesc": "Wir benachrichtigen dich per E-Mail bei passenden neuen Artikeln.",
      "errQuery": "Suchbegriff muss mindestens 2 Zeichen haben",
      "errEmail": "Bitte gültige E-Mail eingeben",
      "errSave": "Fehler beim Speichern des Suchalarms",
      "unsubscribed": "Abgemeldet",
      "unsubscribedDesc": "Du erhältst keine Benachrichtigungen mehr für diese Suche.",
      "unsubscribeError": "Abmeldung fehlgeschlagen",
      "unsubscribeErrorDesc": "Dieser Link ist möglicherweise abgelaufen.",
      "backToClassifieds": "Verkaufen / Verloren / Gefunden durchsuchen"
    },

    // Settings, Profile, Legal links, Help, Account
    "legal": "Rechtliches",
    "nearbyDeals": "Angebote & Aktionen in der Nähe",
    "nearbyDealsDesc": "Erhalte gelegentliche gesponserte Angebote von Unternehmen, denen du nicht folgst",
    "enableNotificationsFirst": "Folge einem Unternehmen oder aktiviere Benachrichtigungen, um deine Einstellungen zu verwalten.",
    "termsOfService": "Nutzungsbedingungen",
    "privacyPolicy": "Datenschutzrichtlinie",
    "cookiePolicy": "Cookie-Richtlinie",
    "disputePolicy": "Streitrichtlinie",
    "deleteData": "Meine Daten löschen",
    "deleteAccountTitle": "Konto & Daten löschen",
    "whatWillBeDeleted": "Was gelöscht wird:",
    "deleteItem1": "Dein Benutzerkonto und Anmeldedaten",
    "deleteItem2": "Geschäftseintrag und Fotos (falls zutreffend)",
    "deleteItem3": "Favoriten und gespeicherte Einstellungen",
    "deleteItem4": "Alle zugehörigen persönlichen Daten",
    "reasonOptional": "Grund (optional)",
    "reasonPlaceholder": "Erzähl uns, warum du gehst...",
    "requestDeletion": "Kontolöschung beantragen",
    "emailDirectly": "Du kannst deine Anfrage auch direkt per E-Mail senden an:",
    "requestReceived": "Anfrage eingegangen",
    "requestReceivedDesc": "Dein Löschantrag wurde übermittelt. Wir bearbeiten ihn innerhalb von 30 Tagen.",
    "contactDirectly": "Du kannst uns auch direkt kontaktieren unter",
    "changePasswordTitle": "Passwort ändern",
    "memberSince": "Mitglied seit",
    "businessAccount": "Geschäftskonto",
    "regularAccount": "Benutzerkonto",
    "businessDashboard": "Geschäfts-Dashboard",
    "businessNotFound": "Geschäftsprofil nicht gefunden",
    "listingUnavailable": "Dieser Geschäftseintrag ist nicht mehr verfügbar.",
    "duplicateViewBtn": "Eintrag ansehen",
    "claimRetiredTitle": "Beanspruchen ist nicht mehr möglich",
    "claimRetiredBody": "Find-2-Day funktioniert jetzt über Selbstregistrierung. Wenn Sie ein Unternehmen führen, erstellen Sie einfach Ihren eigenen Eintrag — ein vorhandener Datensatz muss nicht beansprucht werden.",
    "claimRetiredRegister": "Unternehmen registrieren",
    "backToHome": "Zurück zur Startseite",
    "townCityLabel": "Ort / Stadt", "townCityPlaceholder": "z. B. Madrid", "countryLabel": "Land", "countrySelect": "Land auswählen", "regionLabel": "Region / Bundesland / Provinz", "regionPlaceholder": "z. B. Andalusien", "localAreaLabel": "Stadtteil / Bezirk", "postcodeLabel": "Postleitzahl", "regionLabel2": "Region / Bundesland", "provinceLabel": "Provinz", "provincePlaceholder": "z. B. Almería", "mapView": "Karte", "mapNoCoords": "Für diese Unternehmen gibt es noch keine Kartenstandorte. Wechsle zur Listenansicht, um alle Ergebnisse zu sehen.", "directionsBtn": "Route", "filterCountry": "Land", "filterRegion": "Region / Bundesland", "filterProvince": "Provinz", "filterTown": "Ort / Stadt", "allCountries": "Alle Länder", "allRegions": "Alle Regionen", "allProvinces": "Alle Provinzen", "allTowns": "Alle Orte", "locationFilterLabel": "Standort",
    "faqTitle": "Häufig gestellte Fragen",
    "faq1q": "Wie registriere ich mein Geschäft?",
    "faq1a": "Klicke auf 'Als Unternehmen beitreten' und folge dem 5-Schritte-Registrierungsprozess.",
    "faq2q": "Wie funktioniert die Abrechnung?",
    "faq2a": "Alle Pläne beginnen sofort nach Zahlung — keine kostenlose Testphase.",
    "faq3q": "Wann wird mein Geschäft sichtbar?",
    "faq3a": "Nach Admin-Genehmigung, normalerweise innerhalb von 24-48 Stunden.",
    "contactUs": "Kontaktiere uns",
    "trialPeriod": "Abrechnung",
    "subscriptionPlans": "Abonnement-Pläne",
    "allRightsReserved": "Alle Rechte vorbehalten.",
    "aboutDescription": "Find-2-Day ist deine lokale Entdeckungsplattform. Finde Restaurants, Events, Aktivitäten und Angebote in deiner Nähe.",

    "findAmazing": "Finde tolle Erlebnisse in deiner Nähe",
    "eventsWillAppear": "Events lokaler Geschäfte erscheinen hier bald!",
    "offersWillAppear": "Schau bald wieder vorbei für tolle Angebote!",
    "startExploring": "Beginne Geschäfte zu erkunden und speichere deine Favoriten!",

    // Business detail, reviews, claims
    "changePassword": "Passwort ändern",
    "backToHome": "Zur Startseite",
    "days": "Tage",
    "enableNotifications": "Benachrichtigungen aktivieren",
    "notificationSettings": "Benachrichtigungseinstellungen",
    "visitWebsite": "Website besuchen",
    "featuresAmenities": "Ausstattung & Angebote",
    "noFeaturesYet": "Noch keine Funktionen oder Dienste hinzugefügt.",
    "addFeatures": "Funktionen & Dienste hinzufügen",
    "featureEditHint": "Klicke auf Elemente, um sie hinzuzufügen oder zu entfernen. Speichere danach.",
    "reviewCount": "Bewertungen",
    "reviewBy": "Bewertung von",
    "ratingRequired": "Bitte eine Bewertung abgeben",
    "reviewTextMin": "Mindestens 10 Zeichen",
    "reviewTextMax": "Maximal 500 Zeichen",
    "charsRemaining": "Zeichen übrig",
    "submittingReview": "Wird gesendet...",
    "reviewSubmitted": "Bewertung eingereicht!",
    "alreadyReviewed": "Du hast bereits eine Bewertung geschrieben",
    "removeFavorite": "Aus Favoriten entfernen",
    "reportListing": "Eintrag melden",
    "reportReview": "Bewertung melden",
    "loginToReport": "Zum Melden anmelden",
    "loginToClaim": "Zum Beanspruchen anmelden",
    "signInToClaim": "Anmelden zum Beanspruchen",
    "claimThisBusiness": "Geschäft beanspruchen",
    "claimNowBtn": "Jetzt beanspruchen",
    "claimBanner": "Ist das dein Geschäft?",
    "claimTopBannerText": "Beanspruche diesen Eintrag, um ihn zu verwalten",
    "claimToUnlock": "Beanspruche den Eintrag zum Verwalten",
    "claimSubmitted": "Beanspruchung eingereicht",
    "claimSubmittedDesc": "Wir prüfen deine Anfrage und melden uns.",
    "claimAutoApproved": "Automatisch genehmigt",
    "claimAutoApprovedDesc": "Deine Beanspruchung wurde genehmigt!",
    "claimAlreadyClaimed": "Bereits beansprucht",
    "claimAlreadyPending": "Beanspruchung wird geprüft",
    "claimStatusApproved": "Genehmigt",
    "claimStatusPending": "Wird geprüft",
    "claimStatusRejected": "Abgelehnt",
    "claimError": "Fehler bei der Beanspruchung",
    "alreadyListedClaim": "Dieses Geschäft ist bereits eingetragen",
    "unclaimedListing": "Nicht beanspruchter Eintrag",
    "unclaimedContactNotice": "Kontaktdaten möglicherweise nicht aktuell",
    "verifiedOwner": "Verifizierter Inhaber",
    "verifyingEmail": "E-Mail wird verifiziert...",
    "verifySuccessDesc": "Deine E-Mail wurde verifiziert.",
    "resetPasswordError": "Fehler beim Zurücksetzen des Passworts",
    "token": "Token",
    "expirestoday": "Läuft heute ab",
    "groupSizesWelcome": "Gruppengrößen willkommen",
    "firstFollowBoost": "Folge Geschäften für Updates!",
    "followEmptyTitle": "Keine gefolgten Geschäfte",
    "followEmptyDesc": "Folge Geschäften, um Updates zu erhalten",
    "followEmptyCta": "Geschäfte entdecken",
    "notifIOSShort": "iOS: Zum Home-Bildschirm hinzufügen",
    "notifAndroidShort": "Android: Installieren",
    "notifGenericShort": "Benachrichtigungen aktivieren",
    "disputePolicyTitle": "Streit- und Melderichtlinie",
    "charity.applyForListing": "Kostenlos für Gemeinde- oder Wohltätigkeitseintrag bewerben",
    "charity.charityBadge": "Gemeinde & Wohltätigkeit",
    "planBasic": "Basis",
    "perYear": "/Jahr",
    "per6Months": "/6 Mon.",
    "per12Months": "/12 Mon.",
    "ivaIncluded": "MwSt. inkl.",
    "basicMonthlyHint": "Founding-Business-Angebot · 12 Monate KOSTENLOS — keine Karte erforderlich",
    "basicRestrictions": "Nur Eintrag + Fotos + Kontakt. Keine Events, Angebote oder beworbene Promotions.",
    "upgradeFromBasicTitle": "Events, Angebote & Funktionen freischalten",
    "upgradeFromBasicDesc": "Alle Unternehmen sind derzeit 12 Monate kostenlos unter dem Founding-Business-Angebot — Veranstaltungen, Angebote, geförderte Promotions und alle Listing-Funktionen sind während des Founding-Zeitraums kostenfrei enthalten.",
    "earnUpToPerSignup": "Verdiene bis zu 20 € pro Anmeldung",
    "minPayoutHint": "Mindestens {{amount}} € Guthaben für Auszahlung.",
    "payoutProgress": "Auszahlungs-Fortschritt",
    "balanceLabel": "Guthaben",
    "eligibleForPayout": "Auszahlbar",
    "notYetEligible": "Noch nicht auszahlbar — weiter so!",
    "pendingMaturing": "Ausstehend (in Reifung)",
    "pendingMaturingDesc": "Provisionen in der 14-tägigen Freigabefrist.",
    "availableForPayout": "Verfügbar zur Auszahlung",
    "availableForPayoutDesc": "{{days}}-Tage-Frist abgelaufen und auszahlungsbereit.",
    "clearanceTooltip": "Provisionen werden {{days}} Tage nach Zahlungsfreigabe verfügbar — angepasst an das Rückbuchungsfenster unseres Zahlungsanbieters. Du erhältst den vollen Betrag, die Reifung dauert nur {{days}} Tage.",
    "maturesInDays": "Reift in {{count}} Tag",
    "maturesInDays_plural": "Reift in {{count}} Tagen",
    "availableNow": "Verfügbar",
    "min": "min",
    "payoutCycleNote": "Auszahlungen werden nach einer {{days}}-tägigen Reifungsfrist (Rückerstattungsfenster) geprüft und monatlich vom Admin-Team bearbeitet.",
    "calendar": { "addToCalendar": "Zum Kalender hinzufügen", "icsDownload": "Apple / Outlook (.ics)", "icsHint": "Universelle Kalenderdatei", "googleCalendar": "Google Kalender", "googleHint": "Öffnet sich in neuem Tab" },
    "previewYourListing": "Eintrag als Vorschau ansehen",
    "previewYourListingHint": "Sieh, wie dein Eintrag aussehen wird, bevor du zahlst. Öffnet sich in neuem Tab — es wird nichts gespeichert.",
    "waiverTitle": "Sofortiger Dienstbeginn",
    "waiverLabel": "Ich stimme zu, dass mein Eintrag sofort veröffentlicht wird und verzichte auf mein 14-tägiges Widerrufsrecht gemäß EU-Verbraucherrecht.",
    "waiverRequired": "Sie müssen den Verzicht auf das Widerrufsrecht akzeptieren, um fortzufahren.",
    "waiverLegalNote": "Gemäß EU-Richtlinie 2011/83/EU, Art. 16 Buchstabe m (digitale Inhalte / sofort bereitgestellte Dienstleistungen).",
    "emergency": {
      "title": "Notrufnummern", "subtitle": "Region Almería — zum Anrufen tippen",
      "disclaimerTitle": "Bei lebensbedrohlicher Notlage:", "disclaimerBody": "Diese Seite ist nur informativ.",
      "callNow": "112 jetzt anrufen", "tapToCall": "Zum Anrufen tippen",
      "footerNote": "Zuletzt geprüft: Februar 2026. Wichtige Informationen immer bei offiziellen Stellen verifizieren.",
      "euEmergency": "Notruf (EU)", "euEmergencyDesc": "Einheitliche Nummer für Polizei, Rettungsdienst und Feuerwehr in der EU",
      "nationalPolice": "Policía Nacional", "nationalPoliceDesc": "Nationalpolizei — schwere Straftaten, Ausweise",
      "guardiaCivil": "Guardia Civil", "guardiaCivilDesc": "Ländliche Gebiete, Straßen, Grenzen",
      "localPolice": "Policía Local", "localPoliceDesc": "Kommunale Vorfälle, Parken, lokale Angelegenheiten",
      "medical": "Rettungsdienst", "medicalDesc": "Krankenwagen und medizinische Notfälle",
      "fire": "Feuerwehr", "fireDesc": "Brände, Rettungen, Überflutungen",
      "dvSupport": "Hilfe bei häuslicher Gewalt", "dvSupportDesc": "24/7 kostenlos und vertraulich",
      "torrecardenas": "Hospital Torrecárdenas", "torrecardenasDesc": "Hauptkrankenhaus in Almería",
      "ukConsulate": "Britisches Konsulat (Málaga)", "ukConsulateDesc": "Unterstützung für britische Bürger",
      "ieConsulate": "Irische Botschaft (Madrid)", "ieConsulateDesc": "Unterstützung für irische Bürger",
      "cat": { "primary": "Notfall", "police": "Polizei", "medical": "Medizin", "fire": "Feuer", "support": "Hilfe", "consulate": "Konsulat" }
    },
    "holidays": {
      "title": "Feiertage", "subtitle": "Spanien & Andalusien — 2026",
      "nextHoliday": "Nächster Feiertag", "today": "Heute", "tomorrow": "Morgen", "inNDays": "in {{count}} Tagen",
      "footerNote": "Termine können je nach Gemeinde variieren.",
      "scope": { "national": "National", "andalusia": "Andalusien", "almeria": "Almería" },
      "month": {
        "january": "Januar", "february": "Februar", "march": "März", "april": "April",
        "may": "Mai", "june": "Juni", "july": "Juli", "august": "August",
        "september": "September", "october": "Oktober", "november": "November", "december": "Dezember"
      },
      "newYear": "Neujahr", "epiphany": "Dreikönigstag", "andalusiaDay": "Tag Andalusiens",
      "maundyThursday": "Gründonnerstag", "goodFriday": "Karfreitag", "labourDay": "Tag der Arbeit",
      "sanJuan": "San Juan (Almería)", "assumption": "Mariä Himmelfahrt", "virgenDelMar": "Virgen del Mar (Almería)",
      "nationalDay": "Spanischer Nationalfeiertag", "allSaints": "Allerheiligen",
      "constitutionDay": "Tag der Verfassung", "immaculate": "Mariä Empfängnis", "christmas": "Weihnachten"
    },

    // Added Feb 2026 — auth, inbox, data deletion, trial, safety bulletin, guide
    "common": {
      "back": "Zurück",
      "loading": "Lädt…",
      "optional": "optional"
    },
    "auth": {
      "pwStrongPlaceholder": "Wähle ein sicheres Passwort",
      "pwReenter": "Passwort erneut eingeben",
      "pwReenterFull": "Bitte Passwort erneut eingeben",
      "pwMin6": "Mindestens 6 Zeichen",
      "pwConfirm": "Passwort bestätigen"
    },
    "businessAuth": {
      "loginTitle": "Unternehmen-Login",
      "loginSubtitle": "Melde dich an, um dein Unternehmensprofil zu verwalten",
      "signIn": "Anmelden",
      "signingIn": "Anmeldung läuft…",
      "noAccount": "Noch kein Konto?",
      "registerHere": "Hier registrieren",
      "backHome": "Zurück zur Startseite",
      "errInvalidType": "Falscher Kontotyp. Bitte nutze ein Unternehmenskonto.",
      "errLoginFailed": "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
      "registerTitle": "Unternehmen registrieren",
      "step1": "Schritt 1: Konto erstellen",
      "step2": "Schritt 2: Unternehmensdaten",
      "phName": "Name deines Unternehmens",
      "phCategory": "Kategorie wählen",
      "phAddress": "Straße und Hausnummer"
    },
    "helperAuth": {
      "loginTitle": "Partner-Login",
      "loginSubtitle": "Melde dich an, um deine Empfehlungen und Provisionen zu sehen"
    },
    "inbox": {
      "title": "Benachrichtigungen",
      "typeEvent": "Veranstaltung", "typeOffer": "Angebot", "typeSystem": "System", "typeSafety": "Sicherheit",
      "justNow": "gerade eben", "minsAgo": "vor {{n}} Min.", "hoursAgo": "vor {{n}} Std.", "daysAgo": "vor {{n}} T.",
      "unreadCount": "{{n}} ungelesen", "sponsoredCount": "{{n}} gesponsert",
      "settingsTitle": "Benachrichtigungseinstellungen", "markAllRead": "Alle als gelesen markieren",
      "errLoad": "Benachrichtigungen konnten nicht geladen werden", "errMarkAll": "Nicht alle als gelesen markiert",
      "emptyEnableTitle": "Benachrichtigungen aktivieren",
      "emptyEnableBody": "Aktiviere Benachrichtigungen auf einer Unternehmensseite oder in den Einstellungen, um Hinweise hier zu erhalten.",
      "openSettings": "Einstellungen öffnen",
      "emptyTitle": "Noch keine Benachrichtigungen",
      "emptyBody": "Wenn Unternehmen, denen du folgst, neue Veranstaltungen oder Angebote posten, erscheinen sie hier.",
      "sponsored": "Gesponsert", "sponsoredTitle": "Dies ist ein gefördertes Angebot",
      "unread": "Ungelesen", "fallbackTitle": "Benachrichtigung"
    },
    "dataDeletion": {
      "title": "Konto löschen",
      "subtitle": "Diese Aktion ist endgültig und kann nicht rückgängig gemacht werden.",
      "doneTitle": "Konto gelöscht",
      "doneBody": "Dein Konto wurde dauerhaft entfernt. Öffentliche Bewertungen wurden anonymisiert. Du kannst dich jederzeit mit einem neuen Konto erneut registrieren.",
      "doneSubCancelled": "Dein aktives Abonnement wurde gekündigt.",
      "doneUnclaimed": "Dein Unternehmenseintrag wurde in einen nicht beanspruchten Zustand zurückversetzt.",
      "backHome": "Zurück zur Startseite",
      "signInRequired": "Anmeldung erforderlich",
      "signInBody": "Du musst angemeldet sein, um dein Konto zu löschen.",
      "goSignIn": "Zur Anmeldung",
      "deletedHeading": "Endgültig gelöscht",
      "deletedItem1": "Dein Konto, E-Mail und Passwort",
      "deletedItem2": "Gespeicherte Favoriten und Benachrichtigungs-Posteingang",
      "deletedItem3": "Benachrichtigungsabonnements und Geräteverknüpfungen",
      "deletedItem4": "Alle ausstehenden Meldungen oder Anspruchsanfragen",
      "anonHeading": "Anonymisiert (öffentlich erhalten, ohne deinen Namen)",
      "anonItem1": "Deine Bewertungen — erscheinen als 'Gelöschter Nutzer' auf der Unternehmensseite",
      "anonItem2": "Moderations-/Audit-Einträge, die bereits bearbeitet wurden",
      "bizHeading": "Wenn du einen Unternehmenseintrag besitzt",
      "bizItem1": "Dein Abonnement wird sofort über Stripe gekündigt",
      "bizItem2": "Der Eintrag wird auf 'nicht beansprucht' zurückgesetzt",
      "bizItem3": "Du kannst ihn später mit einem neuen Konto erneut beanspruchen",
      "legalHeading": "Aus rechtlichen/steuerlichen Gründen gespeichert",
      "legalItem1": "Stripe-Rechnungen (spanisches Steuerrecht: 6 Jahre Aufbewahrung)",
      "legalItem2": "Anonymisierter Löschungs-Auditeintrag (2 Jahre)",
      "reasonLabel": "Grund für den Austritt",
      "reasonPlaceholder": "Hilf uns besser zu werden — warum gehst du?",
      "typeDeleteLead": "Tippe", "typeDeleteTrail": "zur Bestätigung",
      "deleting": "Wird gelöscht…",
      "deletePermanent": "Mein Konto dauerhaft löschen",
      "cancelKeep": "Abbrechen, Konto behalten",
      "errDefault": "Konto konnte nicht gelöscht werden. Bitte erneut versuchen."
    },
    "trial": {
      "signupTitle": "Starte mit einer kostenlosen 60-Tage-Testphase — keine Karte nötig",
      "signupBody": "Teste Find-2-Day 60 Tage kostenlos. Füge jederzeit vor Tag 60 eine Zahlungsmethode hinzu. Wenn du keine hinzufügst, pausieren deine Veranstaltungen und Angebote automatisch — dein Eintrag bleibt sichtbar.",
      "signupCta": "60 Tage kostenlos testen — keine Karte nötig",
      "includesTrialBadge": "Beinhaltet 60 Tage kostenlose Testphase — keine Karte nötig",
      "instantListingTrialDesc": "Alle Unternehmen sind derzeit 12 Monate kostenlos unter dem Founding-Business-Angebot — keine Karte erforderlich.",
      "bulletReminders": "Wir erinnern dich 14, 7 und 2 Tage vor Ende der Testphase",
      "paymentLabel": "Kostenlose Testphase", "pausedLabel": "Pausiert",
      "feedbackPrompt": "Magst du uns sagen, warum? Es hilft uns, besser zu werden.",
      "feedbackThanks": "Danke — wir schätzen das.",
      "feedbackSend": "Senden",
      "feedbackError": "Feedback konnte gerade nicht gesendet werden.",
      "feedbackNotePlaceholder": "Möchtest du etwas hinzufügen (optional)",
      "reasonNotReady": "Noch nicht bereit",
      "reasonPriceTooHigh": "Preis zu hoch",
      "reasonPreferMonthly": "Monatliche Zahlung bevorzugt",
      "reasonOther": "Anderes"
    },
    "safety": {
      "title": "Community-Sicherheitszentrum",
      "subtitle": "Offizielle Notfall-Updates, Gemeinschaftsberichte und lokale Hilfe bei Vorfällen.",
      "disclaimer": "Kein Polizeidienst. Im Notfall 112 anrufen. Beiträge werden von unserem Team vor Veröffentlichung geprüft. Keine Namen, keine Anschuldigungen, keine Kennzeichen, keine privaten Daten.",
      "empty": "Noch keine Sicherheitsmeldungen für diesen Filter.",
      "submitCta": "+ Meldung einreichen",
      "myPosts": "Meine Meldungen",
      "verifiedResident": "Bestätigte/r Anwohner/in von {{town}}",
      "publishedOn": "Veröffentlicht {{date}}",
      "allTowns": "Alle Orte", "allCategories": "Alle Kategorien",
      "category": {
        "incident_factual": "Vorfall (Fakt)",
        "safety_tip": "Sicherheitstipp",
        "lost_pet": "Entlaufenes Haustier",
        "community_alert": "Community-Warnung"
      },
      "report": {
        "button": "Melden",
        "title": "Diese Meldung melden",
        "placeholder": "Warum ist diese Meldung problematisch?",
        "submit": "Meldung senden",
        "thanks": "Danke — wir prüfen es.",
        "alreadyReported": "Du hast diese Meldung bereits gemeldet."
      },
      "filterTown": "Nach Ort filtern",
      "filterCategory": "Kategorie",
      "categoryHint": {
        "incident_factual": "Eine kurze, sachliche Notiz zu einem Vorfall. Keine Namen, keine Anschuldigungen.",
        "safety_tip": "Ein allgemeiner Tipp, der Nachbarn hilft, sicherer zu sein.",
        "lost_pet": "Vermisstes Haustier. Beschreibe das Tier, den letzten Ort und kontaktiere über die Plattform — keine Privatadressen.",
        "community_alert": "Kurzlebige Warnung (wird nach 24 Stunden automatisch entfernt)."
      },
      "expiresIn": "Sichtbar für {{value}}",
      "submit": {
        "title": "Sicherheitsmeldung einreichen",
        "intro": "Teile eine kurze, sachliche Notiz mit bestätigten Nachbarn in deinem Ort. Jede Meldung wird vor der Veröffentlichung geprüft.",
        "town": "Ort (nur Provinz Almería)",
        "townPlaceholder": "Deinen Ort wählen",
        "categoryLabel": "Um welche Art Meldung handelt es sich?",
        "titleLabel": "Titel",
        "titlePlaceholder": "Kurze Zusammenfassung (max. 80 Zeichen)",
        "bodyLabel": "Details",
        "bodyPlaceholder": "Nur reiner Text. Keine Links, keine Namen, keine Anschuldigungen, keine Kennzeichen, keine privaten Daten. Max. 500 Zeichen.",
        "rules": "Mit dem Einreichen bestätige ich:",
        "rulesNoNames": "Ich habe niemanden namentlich genannt.",
        "rulesNoAccusations": "Ich beschuldige niemanden einer Straftat.",
        "rulesNoPlates": "Ich habe kein Kennzeichen angegeben.",
        "rulesNoPrivate": "Ich habe keine Adresse, Telefonnummer oder andere private Daten eingefügt.",
        "confirmCheckbox": "Ich bestätige: keine Namen, keine Anschuldigungen, keine Kennzeichen, keine privaten Daten.",
        "submitButton": "Zur Prüfung einreichen",
        "needTown": "Wähle einen Ort",
        "needTitle": "Titel hinzufügen (mindestens 4 Zeichen)",
        "needBody": "Details hinzufügen (mindestens 10 Zeichen)",
        "needConfirm": "Bestätigungsfeld ankreuzen",
        "submitting": "Wird gesendet…",
        "successTitle": "Eingereicht — Prüfung läuft",
        "successBody": "Unser Team prüft deinen Beitrag. Du erhältst eine E-Mail, sobald er freigegeben ist oder Änderungen nötig sind.",
        "characters": "{{count}} Zeichen",
        "loginRequired": "Bitte melde dich an, um eine Meldung einzureichen.",
        "signIn": "Anmelden",
        "rateLimitHit": "Limit erreicht — du kannst bis zu 3 Meldungen pro 24 Stunden einreichen."
      },
      "mine": {
        "empty": "Du hast noch keine Meldungen eingereicht.",
        "status": {
          "pending": "Prüfung läuft",
          "approved": "Veröffentlicht",
          "rejected": "Nicht veröffentlicht",
          "expired": "Abgelaufen",
          "takedown": "Entfernt"
        },
        "rejectionReason": "Grund: {{reason}}",
        "back": "Zurück zur Meldung",
        "markFound": "Als gefunden markieren",
        "markFoundSuccess": "Als gefunden markiert — danke für die Info!",
        "markFoundFailed": "Konnte nicht als gefunden markiert werden.",
        "closedFound": "Geschlossen — Haustier gefunden",
        "edit": "Bearbeiten",
        "editHeading": "Meldung bearbeiten",
        "editTown": "Ort",
        "editCategory": "Kategorie",
        "editTitleField": "Titel",
        "editBody": "Details",
        "editPendingNote": "Das Bearbeiten einer veröffentlichten Meldung sendet sie zur erneuten Prüfung, bevor sie wieder live geht.",
        "editCancel": "Abbrechen",
        "editSave": "Änderungen speichern",
        "editSuccessPending": "Gespeichert — deine Meldung ist wieder in Prüfung und geht nach Freigabe live.",
        "editSuccessLive": "Deine Meldung wurde aktualisiert.",
        "editFailed": "Änderungen konnten nicht gespeichert werden. Bitte versuche es erneut.",
        "editLiveNote": "Deine Änderung bleibt sofort live — Follower werden nur benachrichtigt, wenn du es unten auswählst.",
        "editNotifyFollowers": "Follower über diese Aktualisierung benachrichtigen",
        "editSuccessNotified": "Gespeichert — deine Follower wurden über die Aktualisierung benachrichtigt."
      }
    },
    "guideSubInstant": "Dein Eintrag ist live, sobald dein Abo bestätigt ist (oder sofort beim Start der 60-tägigen kostenlosen Testphase im 12-Monats-Plan).",
    "faq2a": "Alle Unternehmen sind derzeit 12 Monate kostenlos unter dem Founding-Business-Angebot — keine Karte, keine Zahlung während des Founding-Zeitraums. Künftige Preise (falls eingeführt) werden rechtzeitig kommuniziert.",

    // PASS 2 (Feb 2026) — Safety Bulletin submit/mine, emergency, holidays, calendar, community
    "emergency": {
      "title": "Notrufnummern",
      "subtitle": "Region Almería — tippe auf eine Nummer, um zu wählen",
      "disclaimerTitle": "Bei lebensbedrohlichem Notfall:",
      "disclaimerBody": "Diese Seite ist informativ und spiegelt möglicherweise nicht die neuesten offiziellen Kontakte wider.",
      "callNow": "rufe sofort 112 an",
      "tapToCall": "Zum Anrufen tippen",
      "footerNote": "Zuletzt geprüft Februar 2026. Wichtige Informationen immer bei offiziellen Stellen überprüfen.",
      "euEmergency": "Notruf (EU)",
      "euEmergencyDesc": "Zentrale Nummer für Polizei, Krankenwagen und Feuerwehr in der EU",
      "nationalPolice": "Policía Nacional",
      "nationalPoliceDesc": "Nationalpolizei — schwere Straftaten, Ausweisdokumente",
      "guardiaCivil": "Guardia Civil",
      "guardiaCivilDesc": "Ländliche Gebiete, Straßen und Grenzen",
      "localPolice": "Policía Local",
      "localPoliceDesc": "Lokale Vorfälle, Parken, kommunale Angelegenheiten",
      "medical": "Medizinischer Notruf",
      "medicalDesc": "Krankenwagen und Notfalldienste",
      "fire": "Feuerwehr",
      "fireDesc": "Bomberos — Brände, Rettungen, Überschwemmungen",
      "dvSupport": "Hilfe bei häuslicher Gewalt",
      "dvSupportDesc": "24/7 vertrauliche Hotline (kostenlos, nicht auf Rechnung)",
      "torrecardenas": "Hospital Torrecárdenas",
      "torrecardenasDesc": "Hauptkrankenhaus in Almería-Stadt",
      "ukConsulate": "Britisches Konsulat (Málaga)",
      "ukConsulateDesc": "Unterstützung für britische Bürger in Südspanien",
      "ieConsulate": "Irische Botschaft (Madrid)",
      "ieConsulateDesc": "Unterstützung für irische Bürger — für ganz Spanien",
      "cat": { "primary": "Notruf", "police": "Polizei", "medical": "Medizinisch", "fire": "Feuer", "support": "Unterstützung", "consulate": "Konsulat" }
    },
    "holidays": {
      "title": "Feiertage",
      "subtitle": "Spanien & Andalusien — 2026",
      "nextHoliday": "Nächster Feiertag",
      "today": "Heute",
      "tomorrow": "Morgen",
      "inNDays": "in {{count}} Tagen",
      "footerNote": "Daten können je nach Gemeinde abweichen. Prüfe ggf. bei deiner Gemeinde.",
      "scope": { "national": "National", "andalusia": "Andalusien", "almeria": "Almería" },
      "month": { "january": "Januar", "february": "Februar", "march": "März", "april": "April", "may": "Mai", "june": "Juni", "july": "Juli", "august": "August", "september": "September", "october": "Oktober", "november": "November", "december": "Dezember" },
      "newYear": "Neujahrstag",
      "epiphany": "Heilige Drei Könige",
      "andalusiaDay": "Tag Andalusiens",
      "maundyThursday": "Gründonnerstag",
      "goodFriday": "Karfreitag",
      "labourDay": "Tag der Arbeit",
      "sanJuan": "San Juan (Almería)",
      "assumption": "Mariä Himmelfahrt",
      "virgenDelMar": "Virgen del Mar (Almería)",
      "nationalDay": "Spanischer Nationalfeiertag",
      "allSaints": "Allerheiligen (Vertagung)",
      "constitutionDay": "Tag der Verfassung",
      "immaculate": "Mariä Empfängnis",
      "christmas": "Weihnachten"
    },
    "calendar": {
      "addToCalendar": "Zum Kalender hinzufügen",
      "icsDownload": "Apple / Outlook (.ics)",
      "icsHint": "Universelle Kalenderdatei",
      "googleCalendar": "Google Kalender",
      "googleHint": "Öffnet in einem neuen Tab"
    },
    "community": {
      "title": "Community-Tools",
      "safetySub": "Bestätigte Nachbarn, sachliche Hinweise",
      "emergencySub": "Polizei, Medizin, 112",
      "holidaysSub": "Spanien & Andalusien 2026"
    }
  }
};

export default de;
